{
  "familyId": "TAA-SOORT-VW",
  "questions": [
    {
      "id": "TAA-SOORT-VW-001",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is het voegwoord in de zin: 'Ik ga naar buiten, want het is mooi weer.'?",
      "options": ["naar", "want", "het", "mooi"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voegwoord herkennen",
            "content": "Een voegwoord verbindt twee zinnen of zinsdelen. Bekende voegwoorden zijn: en, maar, want, of, dus, omdat, dat, als, toen, terwijl.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_herkennen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het voegwoord in deze zin is 'want'. Het verbindt twee zinnen: 'Ik ga naar buiten' en 'het is mooi weer'. Het woord 'want' geeft een reden aan.",
        "solutionSteps": [
          "Zoek het woord dat twee zinnen verbindt",
          "'want' staat tussen 'Ik ga naar buiten' en 'het is mooi weer'",
          "'want' geeft een reden aan → voegwoord ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'naar' een voegwoord is. Maar 'naar' is een voorzetsel — het geeft richting aan ('naar buiten'). Onthoud: een voegwoord verbindt twee zinnen, een voorzetsel staat vóór een zelfstandig naamwoord.",
          "1": "Goed! 'Want' is het voegwoord. Het verbindt twee zinnen en geeft een reden aan.",
          "2": "Je dacht waarschijnlijk dat 'het' een voegwoord is. Maar 'het' is een lidwoord (of aanwijzend voornaamwoord). Onthoud: voegwoorden verbinden zinnen, lidwoorden staan bij zelfstandige naamwoorden.",
          "3": "Je dacht waarschijnlijk dat 'mooi' een voegwoord is. Maar 'mooi' is een bijvoeglijk naamwoord — het beschrijft het weer. Onthoud: voegwoorden verbinden, bijvoeglijke naamwoorden beschrijven."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.preposition-as-conjunction", "label": "Verwart voorzetsel met voegwoord", "optionIndex": 0 },
          { "id": "taa.article-as-conjunction", "label": "Verwart lidwoord met voegwoord", "optionIndex": 2 },
          { "id": "taa.adjective-as-conjunction", "label": "Verwart bijvoeglijk naamwoord met voegwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-SOORT-VW-002",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "multiple_choice",
      "question": "Welk voegwoord past het best in de zin: 'Ik blijf binnen, ___ het regent.'?",
      "options": ["maar", "of", "omdat", "en"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Soorten voegwoorden",
            "content": "Voegwoorden geven een verband aan. 'Omdat' geeft een reden. 'Maar' geeft een tegenstelling. 'Of' geeft een keuze. 'En' voegt iets toe.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_invullen_reden",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Omdat' past het best. De tweede zin ('het regent') geeft de reden waarom je binnen blijft. 'Omdat' is het voegwoord dat een reden aangeeft.",
        "solutionSteps": [
          "Lees de zin: 'Ik blijf binnen' — waarom?",
          "'Het regent' is de reden",
          "Een reden-voegwoord is 'omdat' ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'maar' past. 'Maar' geeft een tegenstelling aan ('Ik wil naar buiten, maar het regent'). Hier wordt een reden gegeven, geen tegenstelling. Onthoud: reden = omdat/want.",
          "1": "Je dacht waarschijnlijk dat 'of' past. 'Of' geeft een keuze aan ('Wil je thee of koffie?'). Hier is geen keuze, maar een reden. Onthoud: keuze = of, reden = omdat.",
          "2": "Goed! 'Omdat' geeft de reden aan waarom je binnen blijft.",
          "3": "Je dacht waarschijnlijk dat 'en' past. 'En' voegt iets toe ('Ik lees en ik schrijf'). Hier wordt een reden gegeven, niet iets toegevoegd. Onthoud: toevoeging = en, reden = omdat."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.contrast-as-reason", "label": "Verwart tegenstelling-voegwoord met reden-voegwoord", "optionIndex": 0 },
          { "id": "taa.choice-as-reason", "label": "Verwart keuze-voegwoord met reden-voegwoord", "optionIndex": 1 },
          { "id": "taa.addition-as-reason", "label": "Verwart toevoeging-voegwoord met reden-voegwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-SOORT-VW-003",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "multiple_choice",
      "question": "Hoeveel voegwoorden staan er in de zin: 'Als het stopt met regenen en de zon schijnt, gaan we naar buiten.'?",
      "options": ["1", "2", "3", "0"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voegwoorden tellen",
            "content": "Zoek alle woorden die zinnen of zinsdelen verbinden. In deze zin: 'als' verbindt de bijzin met de hoofdzin, en 'en' verbindt twee bijzinnen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Er staan 2 voegwoorden in de zin: 'als' en 'en'. 'Als' verbindt de voorwaarde ('het stopt met regenen') met de hoofdzin. 'En' verbindt twee voorwaarden.",
        "solutionSteps": [
          "Zoek woorden die zinnen verbinden",
          "'Als' verbindt de bijzin met de hoofdzin → voegwoord 1",
          "'En' verbindt twee bijzinnen → voegwoord 2",
          "Totaal: 2 voegwoorden ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat er maar 1 voegwoord is. Misschien heb je 'en' over het hoofd gezien. 'En' is ook een voegwoord — het verbindt 'het stopt met regenen' en 'de zon schijnt'. Onthoud: 'en' is een van de meest gebruikte voegwoorden.",
          "1": "Goed! 'Als' en 'en' zijn allebei voegwoorden. Samen verbinden ze drie zinsdelen.",
          "2": "Je dacht waarschijnlijk dat 'met' ook een voegwoord is. Maar 'met' is een voorzetsel ('stopt met regenen'). Onthoud: voegwoorden verbinden zinnen, voorzetsels staan bij een zelfstandig naamwoord of werkwoord.",
          "3": "Je dacht waarschijnlijk dat er geen voegwoorden zijn. Maar 'als' en 'en' zijn allebei voegwoorden. Onthoud: voegwoorden verbinden zinnen of zinsdelen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.miss-conjunction-en", "label": "Vergeet 'en' als voegwoord te tellen", "optionIndex": 0 },
          { "id": "taa.preposition-as-conjunction", "label": "Verwart voorzetsel met voegwoord", "optionIndex": 2 },
          { "id": "taa.no-conjunctions-seen", "label": "Herkent geen voegwoorden in de zin", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-SOORT-VW-004",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN voegwoord?",
      "options": ["omdat", "maar", "snel", "terwijl"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voegwoord of bijwoord?",
            "content": "'Snel' beschrijft hoe iets gebeurt (bijwoord). Voegwoorden verbinden zinnen: omdat, maar, terwijl, want, of, en, dat, als.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_onderscheiden",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Snel' is geen voegwoord maar een bijwoord. Het beschrijft hoe iets gebeurt ('Hij rent snel'). De andere drie — omdat, maar, terwijl — zijn allemaal voegwoorden die zinnen verbinden.",
        "solutionSteps": [
          "Check elk woord: verbindt het twee zinnen?",
          "'Omdat' → reden-voegwoord ✓",
          "'Maar' → tegenstelling-voegwoord ✓",
          "'Snel' → beschrijft hoe iets gebeurt → bijwoord ✗",
          "'Terwijl' → tijd-voegwoord ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'omdat' geen voegwoord is. Maar 'omdat' verbindt een reden-bijzin met een hoofdzin ('Ik blijf binnen omdat het regent'). Onthoud: 'omdat' is een onderschikkend voegwoord.",
          "1": "Je dacht waarschijnlijk dat 'maar' geen voegwoord is. Maar 'maar' verbindt twee zinnen met een tegenstelling ('Ik wil, maar ik kan niet'). Onthoud: 'maar' is een nevenschikkend voegwoord.",
          "2": "Goed! 'Snel' is een bijwoord, geen voegwoord. Het beschrijft hoe iets gebeurt.",
          "3": "Je dacht waarschijnlijk dat 'terwijl' geen voegwoord is. Maar 'terwijl' verbindt twee zinnen die tegelijk gebeuren ('Ik lees terwijl jij kookt'). Onthoud: 'terwijl' is een onderschikkend voegwoord."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.subordinating-not-conjunction", "label": "Denkt dat onderschikkend voegwoord geen voegwoord is", "optionIndex": 0 },
          { "id": "taa.coordinating-not-conjunction", "label": "Denkt dat nevenschikkend voegwoord geen voegwoord is", "optionIndex": 1 },
          { "id": "taa.time-conjunction-not-conjunction", "label": "Denkt dat tijdsvoegwoord geen voegwoord is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-SOORT-VW-005",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "matching",
      "question": "Koppel elk voegwoord aan het juiste verband.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["omdat", "maar", "of", "terwijl"],
        "rightItems": ["tegenstelling", "keuze", "reden", "gelijktijdigheid"],
        "correctMatches": { "0": 2, "1": 0, "2": 1, "3": 3 }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verbanden bij voegwoorden",
            "content": "Elk voegwoord geeft een ander verband aan: omdat = reden, maar = tegenstelling, of = keuze, terwijl = gelijktijdigheid (twee dingen tegelijk).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_verband_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Omdat → reden (waarom iets gebeurt). Maar → tegenstelling (twee dingen die tegenovergesteld zijn). Of → keuze (kiezen tussen twee dingen). Terwijl → gelijktijdigheid (twee dingen tegelijk).",
        "solutionSteps": [
          "Omdat: 'Ik blijf binnen omdat het regent' → reden",
          "Maar: 'Ik wil, maar ik kan niet' → tegenstelling",
          "Of: 'Wil je thee of koffie?' → keuze",
          "Terwijl: 'Ik lees terwijl jij kookt' → gelijktijdigheid"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SOORT-VW-006",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "categorize",
      "question": "Sorteer de voegwoorden: zijn ze nevenschikkend (verbinden hoofdzinnen) of onderschikkend (beginnen een bijzin)?",
      "data": {
        "categories": ["Nevenschikkend", "Onderschikkend"],
        "items": [
          { "text": "want", "correctCategory": 0 },
          { "text": "omdat", "correctCategory": 1 },
          { "text": "maar", "correctCategory": 0 },
          { "text": "als", "correctCategory": 1 },
          { "text": "en", "correctCategory": 0 },
          { "text": "terwijl", "correctCategory": 1 },
          { "text": "dus", "correctCategory": 0 },
          { "text": "dat", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nevenschikkend vs. onderschikkend",
            "content": "Nevenschikkende voegwoorden verbinden twee hoofdzinnen: en, maar, want, of, dus. Onderschikkende voegwoorden beginnen een bijzin: omdat, dat, als, toen, terwijl, hoewel. Ezelsbruggetje: bij onderschikkend staat de persoonsvorm achteraan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_categoriseer_neven_onder",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Nevenschikkende voegwoorden (en, maar, want, dus) verbinden twee hoofdzinnen — de woordvolgorde verandert niet. Onderschikkende voegwoorden (omdat, dat, als, terwijl) beginnen een bijzin — de persoonsvorm gaat naar het einde.",
        "solutionSteps": [
          "Nevenschikkend = verbindt hoofdzinnen (woordvolgorde blijft gelijk)",
          "Onderschikkend = begint een bijzin (persoonsvorm achteraan)",
          "Ezelsbruggetje: en, maar, want, of, dus → nevenschikkend"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SOORT-VW-007",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "categorize",
      "question": "Sorteer de voegwoorden op het verband dat ze aangeven.",
      "data": {
        "categories": ["Reden/oorzaak", "Tegenstelling", "Tijd"],
        "items": [
          { "text": "want", "correctCategory": 0 },
          { "text": "maar", "correctCategory": 1 },
          { "text": "omdat", "correctCategory": 0 },
          { "text": "terwijl", "correctCategory": 2 },
          { "text": "hoewel", "correctCategory": 1 },
          { "text": "toen", "correctCategory": 2 },
          { "text": "doordat", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verbanden bij voegwoorden",
            "content": "Reden/oorzaak: want, omdat, doordat. Tegenstelling: maar, hoewel, toch. Tijd: toen, terwijl, voordat, nadat. Het verband vertelt je welk type voegwoord het is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_categoriseer_verband",
      "variantIndex": 7,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Voegwoorden geven een verband aan. Reden/oorzaak: want, omdat, doordat (waarom?). Tegenstelling: maar, hoewel (toch anders). Tijd: terwijl, toen (wanneer?).",
        "solutionSteps": [
          "Vraag bij elk voegwoord: welk verband geeft het aan?",
          "Reden → want, omdat, doordat",
          "Tegenstelling → maar, hoewel",
          "Tijd → terwijl, toen"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SOORT-VW-008",
      "familyId": "TAA-SOORT-VW",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_voegwoord",
      "questionType": "text_highlight",
      "question": "Markeer het voegwoord in de volgende zin.",
      "data": {
        "text": "De wedstrijd werd afgelast omdat het te hard regende.",
        "correctHighlights": [{ "start": 27, "end": 32 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voegwoord vinden",
            "content": "Een voegwoord verbindt twee zinnen. Zoek het woord dat tussen twee zinsdelen staat en een verband aangeeft (reden, tegenstelling, tijd).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "voegwoord_markeren",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Omdat' is het voegwoord. Het verbindt 'De wedstrijd werd afgelast' met 'het te hard regende' en geeft een reden aan.",
        "solutionSteps": [
          "Zoek het woord dat twee zinnen verbindt",
          "'omdat' staat tussen de hoofdzin en de bijzin",
          "'omdat' geeft een reden aan → voegwoord ✓"
        ]
      },
      "pedagogy": { "dok": 1 }
    }
  ]
}